// skeleton/app/src/app/shared/components/appheader/headercomponent.ts

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LogoutServive } from '../../../logout/logout.service';
import { GlobalsessionhandlerService } from '../../services/globalsessionhandler.service';
import { MenubarService } from '../../services/menunavbar.services';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CommonMessageComponent } from '../common-message/common-message.component';
import { StorageService } from '../../services/token-storage.service';
import { SiteminderAuthService } from '../../../auth/oidc-config.service';
import { Constants } from '../../constants';

@Component({
  selector: 'app-header-component',
  templateUrl: './headercomponent.html',
  styleUrl: './headercomponent.scss',
  standalone: false,
})
export class AppHeaderComponent implements OnInit {
  isUserSignedIn: boolean = false;
  constants: Constants = new Constants();

  constructor(
    private router: Router,
    private logoutservice: LogoutServive,
    private sessionHandlerService: GlobalsessionhandlerService,
    private menubarService: MenubarService,
    private dialog: MatDialog,
    private storage: StorageService,
    private siteminderAuthService: SiteminderAuthService
  ) {}

  ngOnInit(): void {
    try {
      this.logoutservice.currentUserLogin.subscribe({
        next: (message) => {
          try {
            this.isUserSignedIn = message;
          } catch (error) {
            this.logError(
              'Header login status processing failed',
              error
            );
          }
        },
        error: (error) => {
          this.logError(
            'Header login status subscription failed',
            error
          );
        },
      });

      let isSiteminderValid = false;

      try {
        isSiteminderValid =
          this.siteminderAuthService.isTokenValid();
      } catch (error) {
        this.logError(
          'SiteMinder token validation failed',
          error
        );

        isSiteminderValid = false;
      }

      if (isSiteminderValid) {
        this.isUserSignedIn = true;

        this.menubarService.updatedDataSelection(
          true
        );

        return;
      }

      if (!this.isLogoutGuardOn()) {
        this.router.navigate([
          '/login',
        ]);
      }
    } catch (error) {
      this.logError(
        'Header initialization failed',
        error
      );

      if (!this.isLogoutGuardOn()) {
        try {
          this.router.navigate([
            '/login',
          ]);
        } catch (navigationError) {
          this.logError(
            'Login redirect failed',
            navigationError
          );
        }
      }
    }
  }

  toggle(): void {
    try {
      const item =
        document
          .getElementsByClassName(
            'nav-list'
          )
          .item(0) as HTMLElement | null;

      if (!item) {
        return;
      }

      if (
        item.style.display ===
        'none'
      ) {
        item.style.display =
          'block';

        item.style.visibility =
          'visible';

        item.style.opacity = '1';

        item.style.marginLeft =
          '600px';

        item.style.paddingRight =
          '38px';

        document
          .getElementById(
            'nav-toggle'
          )
          ?.classList.add(
            'active'
          );
      } else {
        item.style.display =
          'none';

        item.style.visibility =
          'hidden';

        item.style.opacity = '0';

        document
          .getElementById(
            'nav-toggle'
          )
          ?.classList.remove(
            'active'
          );
      }
    } catch (error) {
      this.logError(
        'Header navigation toggle failed',
        error
      );
    }
  }

  logout(): void {
    try {
      try {
        this.menubarService.updatedDataSelection(
          false
        );
      } catch (error) {
        this.logError(
          'Menu status reset failed',
          error
        );
      }

      try {
        this.logoutservice.changeMessage(
          false
        );

        this.logoutservice.setUserLoginStatus(
          false
        );
      } catch (error) {
        this.logError(
          'Login status reset failed',
          error
        );
      }

      try {
        this.siteminderAuthService.logout();
        return;
      } catch (error) {
        this.logError(
          'SiteMinder logout failed',
          error
        );
      }

      this.clearAppSessionState();

      try {
        this.router.navigate([
          '/login',
        ]);
      } catch (error) {
        this.logError(
          'Login redirect failed',
          error
        );
      }
    } catch (error) {
      this.logError(
        'Header logout failed',
        error
      );
    }
  }

  logoutViaModal(): void {
    try {
      const dialogConfig =
        new MatDialogConfig();

      dialogConfig.width =
        '350px';

      dialogConfig.position = {
        top: '5px',
      };

      dialogConfig.data =
        'Are you sure you want to logout?';

      const logoutRef =
        this.dialog.open(
          CommonMessageComponent,
          dialogConfig
        );

      logoutRef
        .afterClosed()
        .subscribe({
          next: (res) => {
            try {
              if (res) {
                this.logout();
              }
            } catch (error) {
              this.logError(
                'Logout confirmation processing failed',
                error
              );
            }
          },
          error: (error) => {
            this.logError(
              'Logout confirmation failed',
              error
            );
          },
        });
    } catch (error) {
      this.logError(
        'Logout dialog failed',
        error
      );
    }
  }

  private clearAppSessionState(): void {
    try {
      this.storage.remove(
        'CurrentMeuItemUrl'
      );
    } catch (error) {
      this.logError(
        'Menu state cleanup failed',
        error
      );
    }

    try {
      this.storage.remove(
        'selectedDashboardGroup'
      );
    } catch (error) {
      this.logError(
        'Dashboard state cleanup failed',
        error
      );
    }

    try {
      this.storage.remove(
        'selectedProcessId'
      );
    } catch (error) {
      this.logError(
        'Process state cleanup failed',
        error
      );
    }

    try {
      this.storage.remove(
        'selectedOrgInPanel'
      );
    } catch (error) {
      this.logError(
        'Organization state cleanup failed',
        error
      );
    }

    try {
      this.storage.remove(
        'selectedGroupInPanel'
      );
    } catch (error) {
      this.logError(
        'Group state cleanup failed',
        error
      );
    }

    try {
      this.storage.remove(
        'surveyResponsePageFlag'
      );
    } catch (error) {
      this.logError(
        'Survey state cleanup failed',
        error
      );
    }

    try {
      this.storage.remove(
        'LoggedInuserId'
      );
    } catch (error) {
      this.logError(
        'User state cleanup failed',
        error
      );
    }

    try {
      this.storage.remove(
        'LoggedInuserMailId'
      );
    } catch (error) {
      this.logError(
        'User state cleanup failed',
        error
      );
    }

    try {
      this.storage.remove(
        'LoggedInUserTypeId'
      );
    } catch (error) {
      this.logError(
        'User role cleanup failed',
        error
      );
    }

    try {
      this.storage.remove(
        'LoggedInUserTypeDesc'
      );
    } catch (error) {
      this.logError(
        'User role cleanup failed',
        error
      );
    }

    try {
      this.storage.remove(
        'LoggedInuserFirstName'
      );
    } catch (error) {
      this.logError(
        'User state cleanup failed',
        error
      );
    }

    try {
      this.storage.remove(
        'LoggedInUserAgency'
      );
    } catch (error) {
      this.logError(
        'Agency state cleanup failed',
        error
      );
    }

    try {
      this.storage.remove(
        'LoggedInUserAgencyId'
      );
    } catch (error) {
      this.logError(
        'Agency state cleanup failed',
        error
      );
    }

    try {
      this.storage.remove(
        'LoggedInProviderType'
      );
    } catch (error) {
      this.logError(
        'Provider state cleanup failed',
        error
      );
    }

    try {
      this.storage.remove(
        'UserGroupId'
      );
    } catch (error) {
      this.logError(
        'User group cleanup failed',
        error
      );
    }

    try {
      this.sessionHandlerService.clearSession();
    } catch (error) {
      this.logError(
        'Session cleanup failed',
        error
      );
    }
  }

  private isLogoutGuardOn(): boolean {
    try {
      const sessionLogoutFlag =
        sessionStorage.getItem(
          'siteminder_force_logout'
        );

      const localLogoutFlag =
        localStorage.getItem(
          'siteminder_force_logout'
        );

      return (
        sessionLogoutFlag === '1' ||
        localLogoutFlag === '1'
      );
    } catch (error) {
      this.logError(
        'Logout guard check failed',
        error
      );

      return false;
    }
  }

  private logError(
    context: string,
    error: unknown
  ): void {
    try {
      const messages: string[] =
        [];

      let currentError:
        unknown = error;

      let depth = 0;

      while (
        currentError &&
        depth < 5
      ) {
        if (
          currentError instanceof
          Error
        ) {
          messages.push(
            currentError.message ||
              currentError.name
          );

          const nestedError =
            currentError as Error & {
              cause?: unknown;
              innerException?: unknown;
              innerError?: unknown;
            };

          currentError =
            nestedError.cause ??
            nestedError.innerException ??
            nestedError.innerError ??
            null;
        } else if (
          typeof currentError ===
            'object' &&
          currentError !== null &&
          'message' in
            currentError &&
          typeof (
            currentError as {
              message?: unknown;
            }
          ).message ===
            'string'
        ) {
          messages.push(
            (
              currentError as {
                message: string;
              }
            ).message
          );

          currentError = null;
        } else {
          messages.push(
            'Unknown error'
          );

          currentError = null;
        }

        depth++;
      }

      console.error(
        `${context}${
          messages.length
            ? `: ${messages.join(
                ' | '
              )}`
            : ''
        }`
      );
    } catch {
      console.error(context);
    }
  }
}